<template>
    <div class="links" v-if="links.length">
        <template v-for="item in links">
            <a
                v-if="item.link"
                class="hover-link-underlined link"
                :key="item.text"
                :href="item.link"
                target="_blank"
            >
                {{ item.text }}
            </a>
            <router-link
                v-else
                target="_blank"
                class="hover-link-underlined link"
                :key="item.text"
                :to="item.to"
            >
                {{ item.text }}
            </router-link>
        </template>

    </div>
</template>

<script>
export default {
    name: 'ProgramCardLinks',
    props: {
        item: {
            type: Object,
            required: true,
        },

        programLinkText: {
            type: String,
            default: 'Перейти на официальную страницу программы',
        },

        syllabusLinkText: {
            type: String,
            default: 'Посмотреть учебный план',
        },

        courseLinkText: {
            type: String,
            default: 'Перейти на страницу курса',
        },

        webinarLinkText: {
            type: String,
            default: 'Перейти на страницу вебинара',
        },
    },
    data: () => ({
    }),
    computed: {
        links() {
            let items = [];
            if (this.item.entityType === 'program') {
                if (this.item.link) {
                    items.push({ text: this.programLinkText, link: this.item.link });
                }
                if (this.item.syllabusUrl) {
                    items.push({ text: this.syllabusLinkText, link: this.item.syllabusUrl });
                }
            } else if (this.item.educationType === 'rsv_course') {
                items.push({
                    text: this.courseLinkText,
                    to: { name: 'events', params: { type: 'courses', page: 1, id: this.item.foreignCmsId } },
                });
            } else if (this.item.entityType === 'webinar') {
                items.push({
                    text: this.webinarLinkText,
                    to: { name: 'events', params: { type: 'webinars', page: 1, id: this.item.foreignCmsId } },
                });
            }
            return items;
        },
    },
};
</script>

<style lang="scss">
    .links {
        .hover-link-underlined {
            padding-bottom: 4px;

            &:after {
                bottom: 0;
            }
        }
    }
</style>

<style scoped lang="scss">
    @import '~@/styles/rem';

    .links {
        margin-top: 32px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @include on-xs {
            margin-top: 24px;
        }
    }
    .link {
        cursor: pointer;
        display: inline-block;
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #4663AB;
        margin-bottom: 16px;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @include on-xs {
            font-size: 14px;
            line-height: 20px;
        }
    }
</style>